import _ from "lodash";
import TreeList, { Column, Editing, Scrolling, RemoteOperations, Selection } from "devextreme-react/tree-list";
import { memo, useEffect, useLayoutEffect, useRef, useState } from "react";
import { DocumentContentService } from "../../../../services/document/document-content.service";
import { CreateNotification } from "../../../../components/notifier";
import { replaceHTMLtoTitle } from "../../util";
import { Button } from "devextreme-react/data-grid";
import { getEnv } from "../../../../AppConfigs";
import { ISharepointLink, ISharepointUser } from "../../../../models/ISharepoint";
import { IDocumentContent } from "../../../../models/IDocumentContent";
import { SharePointPermissionRole } from "../../../../constants/sharePointConstant";
import "./style.css";
import { convertUserLoginToSharepointUser, isEqualBetweenSharepointUserAndLoginUser } from "../../../../services/util";
import { useHistory, useLocation } from "react-router-dom";
import { EditorHeader } from "./editor-view-header";
import ContentComment from "./editor-content-comment";
import { IComment } from "../../../../models/IComment";
import ContentHistoryModal from "../../modal/content-history-modal";
import { DocumentService } from "../../../../services/document/document.service";
import { DocumentContentLinkService } from "../../../../services/document/document-content-link.service";
import Diagram from "devextreme-react/diagram";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { listKeyWord } from "./keyword";
import { WarningButton } from "./warning-button";
import { EditDocumentLinkModal } from "../../modal/edit-document-link-modal";
import { StatisticsEmployeeService } from "../../../../services/department-viags/statistics-employee.service";
import { Form, Input, InputRef, Modal, Space, Spin, Button as AntButton, Statistic } from "antd";
import { useSearchParams } from "../../../../hook/use-search-params";
import { useDocumentContent } from "../../hooks/document-content/use-document-content";
import { documentStatus } from "../../../../constants";
import { useDocumentInfo } from "../../hooks/documents/use-document-info";
import { useUser } from "../../../../hook";
import { useQueryClient } from "@tanstack/react-query";
import { useUpdateDocumentPublicInfo } from "../../hooks/content-mutation/use-update-document-public-info";
import { EditorContentPermissionModal } from "../../modal/editor-content-permission-modal";
import { Employee } from "../../../../services/department-viags/employee-viags.service";
import { useDocumentContentLink } from "../../hooks/document-content/use-document-content-link";
import { Badge } from "react-bootstrap";
import { useDocumentTags } from "../../../setting/document/document-tags/hooks/useDocumentTags";
import { useCreateDocumentContent } from "../../hooks/content-mutation/use-create-document-content";
import { useDocumentPermission, useUpdateDocumentContent } from "../../hooks";
import { useCreateDocumentLink } from "../../hooks/document-link/use-create-document-link";
import { TinyEditor } from "../../../../components/my-editor/tiny-editor";
import { useCheckGroupUser } from "../../../../hook/use-check-group-user";

function extractHrefsFromHTML(htmlString: string): string[] {
  const hrefs: string[] = [];
  const regex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g;
  let match;
  while ((match = regex.exec(htmlString)) !== null) {
    hrefs.push(match[1]);
  }
  return hrefs;
}

function extractNumbersFromURLs(urls: string[]): string[] {
  return urls.map((url) => {
    const match = url.match(/\/detail\/(\d+)\?/);
    return match && match[1] ? match[1] : "";
  });
}

const pListId = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");

export const EditorContent = memo(() => {
  const [currentItem, setCurrentItem] = useState<IDocumentContent>(null as any);
  const [openContentComment, setOpenContentComment] = useState(false);
  const [openContentHistory, setOpenContentHistory] = useState(false);
  const [valueComment, setValueComment] = useState("");
  const [contentHistory, setContentHistory] = useState<any>([]);
  const [isMultipleChoose] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isShowReadButton, setIsShowReadButton] = useState(false);
  const [titleFormat, setTitleFormat] = useState("" as string);
  const domain = getEnv("REACT_APP_DOCUMENT_DETAILS_URL");
  const [isShowLinkModal, setIsShowLinkModal] = useState(false);

  const [linkModalData, setLinkModalData] = useState({});
  const configUsers = ["chinhy@viags.vn", "canbo1@viags.vn", "anhkn@viags.vn"];

  const inputRef = useRef<InputRef>(null);
  const spanWidthRef = useRef<number>(0);

  //refactor
  const { searchParams, replaceSearchParams } = useSearchParams();
  const { mappedData, isLoading: isLoadingDocumentContent, position } = useDocumentContent();
  const fileId = searchParams.get("fileId");
  const isPublishStatus = searchParams.get("status") === documentStatus.publish.value;
  const action = searchParams.get("action");
  const step = searchParams.get("step");
  const titleId = searchParams.get("titleId");
  const viewMode = searchParams.get("viewMode") || (isPublishStatus || action === "process" ? "preview" : "edit");
  const { data: documentInfo, docReader, isRead } = useDocumentInfo();
  const { userAdmin, user, email } = useUser();
  const { isGroupUser, isLoading: isLoadingGroupUser } = useCheckGroupUser();
  const queryClient = useQueryClient();
  const { mutate, isLoading: isUpdateLoading } = useUpdateDocumentPublicInfo();
  const { hasWritePermission } = useDocumentPermission();
  const url = isPublishStatus
    ? `${domain}/${documentInfo?.docWorkingId}?fileId=${fileId}&action=file&status=publish`
    : `${domain}/${documentInfo?.docId}?fileId=${fileId}&action=file&status=publish`;

  const isOwner = documentInfo?.userEmail?.toLowerCase() === email?.toLowerCase() || hasWritePermission;
  // const { data: fileShareLinks } = useFilePermission();
  const [isOpenPermissionContentModal, setIsOpenPermissionContentModal] = useState(false);
  const [customId, setCustomId] = useState("");
  const { data: linkContentList } = useDocumentContentLink();
  const { getTagLabel } = useDocumentTags();
  const location = useLocation();
  const [form] = Form.useForm();
  const { createDocumentContent } = useCreateDocumentContent();
  const { updateDocumentContent } = useUpdateDocumentContent();
  const isContent = useRef<boolean>(false);
  const isQuote = useRef<boolean>(false);
  const { createDocumentLink } = useCreateDocumentLink();
  const readTime = Date.now() + 1000 * 60;
  const isLoading = isLoadingDocumentContent || isLoadingGroupUser;

  const handleClickButtonDropDown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  let linkTitle: string = "";
  const history = useHistory();

  const configComposeIndex = () => {
    return configUsers.includes(email?.toLowerCase());
  };

  const updateRow = async (e: any) => {
    try {
      const fields = {
        ...e.newData,
        numberEdit: e.oldData.numberEdit + 1,
        prepareVersion:
          documentInfo?.docPublicVersion && documentInfo?.docPublicVersion > 0
            ? documentInfo?.docPublicVersion + 1
            : undefined,
      };
      if (!e.oldData.IsContent && fields.Content) {
        const oldIndex = replaceHTMLtoTitle(e.oldData.Content)?.trim().slice(0, 4);
        const newIndex = replaceHTMLtoTitle(e.newData.Content)?.trim().slice(0, 4);

        if (oldIndex !== newIndex && !configComposeIndex()) {
          CreateNotification({
            title: "Không thể cập nhật",
            body: "Anh/Chị không có quyền cập nhật đầu mục, vui lòng liên hệ quản trị!",
            icon: "/icons/warning.png",
          });
          e.cancel = true;
          return;
        }
        fields.Title = replaceHTMLtoTitle(fields.Content);
        e.oldData.Title = fields.Title;
      }
      if (e.oldData.IsContent) {
        fields.Content = replaceTooltipWords(fields.Content);
        fields.ContentSummary = inputRef.current?.input?.value;
        e.newData.Content = replaceTooltipWords(fields.Content);
      }

      updateDocumentContent({ id: e.oldData.Id, body: fields });
    } catch (error: any) {
      CreateNotification({
        title: "Không thể cập nhật",
        body: "Tiêu đề không vượt quá 255 ký tự",
        icon: "/icons/error.png",
      });
      console.log(error);
      setTimeout(() => {
        window.location.reload();
      }, 5100);
    }

    if (e.newData.Content) {
      const data = { Content: e.newData.Content, numberEdit: e.oldData.numberEdit };
      const href = getHrefFromAnchorTag(e.newData.Content);
      if (href && href.includes("document/detail/")) {
        addWorkingLinkContent(data);
      }
    }
  };

  const getHrefFromAnchorTag = (str: any) => {
    if (typeof str === "string") {
      const anchorTagRegex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/;
      const match = str.match(anchorTagRegex);
      return match ? match[2] : null;
    }
  };

  const getFirstAnchorTitle = (str: any) => {
    if (typeof str === "string") {
      const anchorTagRegex = /<a\s+(?:[^>]*?\s+)?title=(["'])(.*?)\1/;
      const match = str.match(anchorTagRegex);
      return match ? match[2] : null;
    }
  };

  const getTextFromFirstAnchor = (str: any) => {
    if (typeof str === "string") {
      const anchorTagRegex = /<a\b[^>]*>(.*?)<\/a>/;
      const match = str.match(anchorTagRegex);
      return match ? match[1] : null;
    }
  };

  const getFirstAnchorId = (str: any) => {
    if (typeof str === "string") {
      const anchorTagRegex = /<a\s+(?:[^>]*?\s+)?id=(["'])(.*?)\1/;
      const match = str.match(anchorTagRegex);
      return match ? match[2] : null;
    }
  };

  const getDocumentInfo = async (id: any) => {
    try {
      const res = await DocumentService.getPublicDocumentInfoFromWorkingDocument(id, pListId);
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const addWorkingLinkContent = async (e: any) => {
    const numberEdit = await getNumberEdit(e.Content);
    const urlStrings = extractHrefsFromHTML(`${e.Content}`);
    const ids = extractNumbersFromURLs(urlStrings);
    const newIdArr = [...new Set(ids)];
    (async () => {
      ids.forEach(async (id) => {
        const documentLinkInfo = await getDocumentInfo(id);
        if (documentLinkInfo) {
          const { Title, docTypeId, docCode, fileId, docUrl, effectiveTo } = documentLinkInfo;
          const fields = {
            Title: documentInfo?.Title,
            docId: documentInfo?.docId,
            docCode: documentInfo?.docCode,
            docTypeId: documentInfo?.docTypeId,
            docInfoLookupId: documentInfo?.id,
            docFileId: documentInfo?.fileId,
            docUrl: documentInfo?.docUrl,
            docLinkId: id,
            docLinkTitle: Title,
            docLinkTypeId: docTypeId,
            docLinkCode: docCode,
            docLinkTypeCode: docCode,
            docLinkFileId: fileId,
            docLinkUrl: docUrl,
            docLinkExpiredDate: effectiveTo,
          };
          createDocumentLink(fields);
        }
        if (newIdArr) {
          const data: any = {
            fields: {
              docId: documentInfo?.docId + "",
              Title: documentInfo?.Title,
              docCode: documentInfo?.docCode,
              docLinkPosition: getTextFromFirstAnchor(e.Content),
              Content: getFirstAnchorTitle(e.Content),
              ContentId: getFirstAnchorId(e.Content),
              ContentLastModified: numberEdit,
              docTypeId: documentInfo?.docTypeId,
              docLinkId: id,
              docLinkCode: "",
              docLinkTitle: documentLinkInfo?.Title,
              docLinkType: documentLinkInfo?.docTypeId,
            },
          };
          try {
            await DocumentContentLinkService.addContentLink(data);
            queryClient.invalidateQueries({ queryKey: ["document-content-link"] });
          } catch (error) {
            console.log(error);
          }
        }
      });
    })();
  };

  const getHyperLink = (e: any) => {
    let titleId: any = null;
    let titleUrl: any = null;
    let copyLinkContent: any = null;
    let contentPara: any = null;
    getRoot(e.row.node);
    contentPara = reverseStringByDelimiter(linkTitle, " | ") + getPositionContent(e.row);
    titleId = e.row.node.data.IsContent ? e.row.node.parent.data.Id : e.row.node.data.Id;
    titleUrl = url + `#title-${titleId}`;
    copyLinkContent = replaceHTMLtoTitle(e.row.node.data.Content);
    linkTitle = "";
    setLinkModalData({ linkTitle: contentPara, linkContent: copyLinkContent, linkUrl: titleUrl, row: e.row });
    setIsShowLinkModal(true);
  };

  const countRomanNumerals = (arr: any): number => {
    // Mảng chứa các ký tự La Mã
    const romanNumerals: string[] = [];
    Array.from({ length: 100 }).forEach((_, i) => {
      romanNumerals.push((i + 1).toString());
    });

    let count = 0;

    arr.forEach((e: any, index: number) => {
      const title: string = replaceHTMLtoTitle(arr[index]) || "";
      const parts = title.split(".");
      const numeral = parts[0].trim();

      // Kiểm tra xem số thứ tự có phải là số La Mã hay không
      if (romanNumerals.includes(numeral)) {
        count++;
        if (numeral === "1") setTitleFormat(arr[index]);
      }
    });

    return count;
  };

  const getIndexContent = (count: number) => {
    const valueMap = Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i));
    return valueMap[count];
  };

  const autoFormatEditor = (node: any) => {
    let content = "";
    const parentNode = node.component.getNodeByKey(node.data.CustomParentId);
    const childrenData = parentNode.hasChildren
      ? !isContent?.current
        ? parentNode.children.filter((child: any) => !child.data.IsContent)
        : parentNode.children.filter((child: any) => child.data.IsContent && !child.data.isQuote)
      : [];
    const numberChildren = childrenData.length;
    const parentTitle = replaceHTMLtoTitle(parentNode.data.Content) || "";
    const indexNumberTitle = parentTitle.split(" ")[0];

    const currentTitle: string = replaceHTMLtoTitle(node.data.Content) || "";
    const decodeContent = _.unescape(currentTitle).trim();
    if (!isContent?.current)
      content = decodeContent.replace(decodeContent, `${indexNumberTitle}${numberChildren}. ${decodeContent}`);
    else {
      const contentLength = node.data.Content.length;
      const pIndex = node.data.Content.indexOf("<p");
      const startIndex = node.data.Content.indexOf(">", pIndex) + 1;
      let endIndex = startIndex;
      if (node.data.Content.slice(contentLength - 4) === "</p>") {
        endIndex = node.data.Content.lastIndexOf("</p>");
      }
      const text = node.data.Content.slice(startIndex, endIndex);
      if (parentNode.data.IsContent) {
        content = node.data.Content.replace(text, `${indexNumberTitle}${numberChildren + 1}) ${text}`);
        if (node.data.Content.startsWith("<table")) {
          content = indexNumberTitle + " " + (numberChildren + 1) + ") " + node.data.Content;
        }
      } else {
        const charIndex = getIndexContent(numberChildren);
        const contentWithIndex = node.data.Content.replace(text, `${charIndex}. ${text}`);
        content =
          contentWithIndex.replace(
            "<span>",
            `<span style="font-family: 'times new roman', times, serif; font-size: 12pt; ">`,
          ) + `</span>`;
        if (node.data.Content.startsWith("<table")) {
          content = charIndex + ". " + node.data.Content;
        }
      }
    }
    return content;
  };

  const replaceTooltipWords = (content: any) => {
    const replaceText = replaceHTMLtoTitle(content) || "";
    const textContent = _.unescape(replaceText);
    const keyWordArr = listKeyWord.filter((e: any) => textContent?.includes(e.value));
    if (keyWordArr.length > 0) {
      keyWordArr.forEach((obj: any) => {
        const linkElement = document.createElement("span");
        linkElement.setAttribute("title", obj?.label || "");
        linkElement.textContent = obj.value;
        const finalContent = content.replace(obj.value, linkElement.outerHTML);
        content = finalContent;
      });
    }
    return content;
  };

  //Khi init thi lay quyen tu file
  const newRow = async (e: any) => {
    try {
      let shareLinks: any = undefined; //*
      if (e.data.CustomParentId) {
        const parent = e.component.getNodeByKey(e.data.CustomParentId);
        if (parent?.data) {
          shareLinks = parent.data.ShareLinks;
        }
      }

      const titleArr = mappedData.filter((e: any) => !e.CustomParentId).map((e: any) => e.Content);
      let count = 0;
      let title = "";

      if (titleArr.length > 0 && !e.data.CustomParentId) {
        count = countRomanNumerals(titleArr) + 1;
        let titleFormatContent: string = "";
        if (titleFormat) {
          titleFormatContent = replaceHTMLtoTitle(titleFormat) || "";
        }
        const romanNumber = count + ". ";
        const contentWithoutFormat = replaceHTMLtoTitle(e.data.Content) || "";
        const finalContent = _.unescape(contentWithoutFormat);
        title = romanNumber.concat(finalContent);
        e.data.Content = `<p><strong><span style="font-family: 'times new roman', times, serif; font-size: 14pt; text-transform: uppercase;">${titleFormat.replace(
          titleFormatContent,
          title,
        )}</span></strong></p>`;
      } else if (!isContent?.current) {
        e.data.Content = `<p><strong><span style="font-family: 'times new roman', times, serif; font-size: 12pt;">${autoFormatEditor(
          e,
        )}</span></strong></p>`;
        title = replaceHTMLtoTitle(e.data.Content)?.toUpperCase() || "";
      } else if (isContent?.current) {
        title = ``;
        if (!isQuote.current) {
          e.data.Content = replaceTooltipWords(e.data.Content);
          e.data.Content = autoFormatEditor(e);
        }
      }

      const fields = {
        CustomId: e.key,
        CustomParentId: e.data.CustomParentId === 0 ? null : e.data.CustomParentId,
        Title: title,
        Content: e.data.Content,
        isQuote: isQuote.current,
        ContentSummary: inputRef.current?.input?.value,
        FileId: fileId,
        Position: position,
        IsContent: isContent.current,
        ShareLinks: shareLinks ? JSON.stringify(shareLinks) : undefined,
        numberEdit: 0,
        prepareVersion:
          documentInfo?.docPublicVersion && documentInfo?.docPublicVersion > 0
            ? documentInfo?.docPublicVersion + 1
            : undefined,
      };

      createDocumentContent(fields);
    } catch (error: any) {
      CreateNotification({
        title: "Không thể thêm",
        body: "Tiêu đề không vượt quá 255 ký tự",
        icon: "/icons/warning.png",
      });
      console.log(error);
    }

    if (e.data.Content) {
      const href = getHrefFromAnchorTag(e.data.Content);
      if (href && href.includes("document/detail/")) {
        addWorkingLinkContent(e.data);
      }
    }
  };

  const reFormatEditor = async (node: any) => {
    const parentNode = node.data.CustomParentId
      ? node.component.getNodeByKey(node.data.CustomParentId)
      : node.component.getRootNode();
    const childrenData = parentNode?.hasChildren
      ? parentNode.children.filter(
          (child: any) => (child.data.IsContent = node.data.IsContent ? child.data.IsContent : !child.data.IsContent),
        )
      : [];
    const parentTitle = replaceHTMLtoTitle(parentNode?.data?.Content) || "";
    const indexNumber = parentTitle?.split(" ")[0] || "";
    let newContentIndexNumber = "";
    for (let index = 0; index < childrenData.length; index++) {
      const e = childrenData[index];
      const contentIndexNumber = replaceHTMLtoTitle(e?.data?.Content)?.split(" ")[0] || "";

      newContentIndexNumber = indexNumber + (index + 1) + ".";
      if (node.data.IsContent && !parentNode.data.IsContent) newContentIndexNumber = getIndexContent(index) + ".";
      if (node.data.IsContent && parentNode.data.IsContent) newContentIndexNumber = indexNumber + (index + 1) + ")";
      if (contentIndexNumber?.localeCompare(newContentIndexNumber) !== 0) {
        const newContent = e.data.Content.replace(contentIndexNumber, newContentIndexNumber);
        const fields = {
          Content: newContent,
          Title: node.data.IsContent ? "" : replaceHTMLtoTitle(newContent) || "",
        };
        updateDocumentContent({ id: e.data.Id, body: fields });
      }
    }
  };

  const deleteRow = async (e: any) => {
    try {
      await DocumentContentService.delete(e.data.Id);
      reFormatEditor(e);
      queryClient.invalidateQueries({ queryKey: ["document-content"] });
    } catch (error: any) {
      CreateNotification({ title: "Không thể xóa", body: error.message, icon: "/icons/warning.png" });
      console.log(error);
    }
  };

  const addNewTitle = (e: any) => {
    isContent.current = false;
    e.component.addRow(e.row.data.CustomId);
  };

  const addNewContent = (e: any) => {
    e.component.addRow(e.row.data.CustomId);
    isContent.current = true;
    isQuote.current = false;
  };

  const addNewQuote = (e: any) => {
    e.component.addRow(e.row.data.CustomId);
    isContent.current = true;
    isQuote.current = true;
  };

  const initNewRow = () => {
    isContent.current = false;
    isQuote.current = false;
  };

  const getTitlesHasComment = (): IDocumentContent[] => {
    let contentHasComment: IDocumentContent[] = [];
    if (mappedData) {
      contentHasComment = [...mappedData.filter((c: IDocumentContent) => c.Comments)];
    }
    return contentHasComment;
  };

  const closeContentComment = async (comment: any) => {
    let arrComment: any = null;
    let arrayComment: any = null;
    const objComment: IComment = {
      Id: crypto.randomUUID(),
      User: convertUserLoginToSharepointUser(user),
      Comment: comment,
      CreateDate: new Date(),
      ModifiedDate: new Date(),
      Reply: null,
    };
    if (currentItem) {
      arrComment = getTitlesHasComment().find((c: IDocumentContent) => c?.Id === currentItem.Id);

      if (arrComment) {
        const contentComments = JSON.parse(arrComment?.Comments);
        let indexCommnetUser: any = contentComments.findIndex(
          (c: any) => c.User.id === convertUserLoginToSharepointUser(user).id,
        );
        if (indexCommnetUser !== -1) {
          contentComments[indexCommnetUser] = objComment;
          await DocumentContentService.updateComment(currentItem.Id, contentComments);
          queryClient.invalidateQueries({ queryKey: ["document-content", fileId] });
        } else {
          arrayComment = contentComments.concat([objComment]);
          await DocumentContentService.updateComment(currentItem.Id, arrayComment);
          queryClient.invalidateQueries({ queryKey: ["document-content", fileId] });
        }
      } else {
        await DocumentContentService.updateComment(currentItem.Id, [objComment]);
        queryClient.invalidateQueries({ queryKey: ["document-content", fileId] });
      }
    }
    setOpenContentComment(!openContentComment);
  };

  const renderHtmlEditor = (cellInfo: any) => {
    const setEditedValue = (value: string) => {
      cellInfo.setValue(value);
    };

    const keyDown = (e: any) => {
      if (e.keyCode === 13) e.stopPropagation();
    };

    return (
      <div className="my-2 tiny__editor-content" id="editor-content">
        <div>
          <TinyEditor value={cellInfo.value} onChangedValue={setEditedValue} onKeyDown={keyDown} />
        </div>
        {documentInfo?.docPublicVersion && documentInfo?.docPublicVersion > 0 ? (
          <Input placeholder="Tóm tắt nội dung sửa đổi" className="mt-2 tiny__editor-content" ref={inputRef} />
        ) : (
          <></>
        )}
      </div>
    );
  };

  const RenderHTMLDiagram = () => {
    return <Diagram id="diagram" />;
  };

  const contentCellRender = (cellInfo: any) => {
    var role = SharePointPermissionRole.read;
    if (cellInfo.data.IsContent) {
      role = checkPermission(cellInfo.data, user);
    }
    if (isOwner) {
      role = SharePointPermissionRole.write;
    }

    const id = `title-${cellInfo.data.Id}`;

    const contentHtml = `
      <div style="display: flex; align-items: flex-start; padding: 5px;">
        ${
          !cellInfo.data.IsContent
            ? `<span style="width: ${Math.max(
                spanWidthRef.current,
                60,
              )}px; flex-shrink: 0; font-size: 14pt; text-transform: uppercase; font-weight: bold">${
                cellInfo.data.prefix ?? ""
              }</span>`
            : `<span style="width: ${Math.max(spanWidthRef.current, 60)}px; flex-shrink: 0;">${
                cellInfo.data.prefix ?? ""
              }</span>`
        }
        <span>${cellInfo.data.content}</span>
      </div>
    `;

    return (
      (role !== SharePointPermissionRole.none ||
        checkReviewers() ||
        checkDetectors() ||
        checkCheckers() ||
        checkApprovers() ||
        cellInfo.data.UserPermissions?.some((role: any) => role.user.email === email?.toLowerCase()) ||
        !documentInfo?.isContentPermission ||
        (isPublishStatus &&
          cellInfo.data.Permissions?.findIndex(
            (e: Employee) => e.employeeEmail === email?.toLowerCase() || e.email === email?.toLowerCase(),
          ) > -1)) && (
        <>
          {documentInfo?.docPublicVersion &&
          cellInfo.data.prepareVersion &&
          cellInfo.data.prepareVersion > documentInfo?.docPublicVersion &&
          documentInfo.docPublicVersion > 0 ? (
            <div
              id={id}
              style={{
                whiteSpace: "normal",
                color: "blue",
                userSelect: "none",
                fontFamily: "times new roman",
              }}
              className="scroll-mt-20"
              dangerouslySetInnerHTML={{ __html: contentHtml }}
            />
          ) : (
            <div
              id={id}
              style={{
                whiteSpace: "normal",
                userSelect: "none",
                fontFamily: "times new roman",
              }}
              className={`scroll-mt-20 ${titleId === id ? "editor-bounceIn" : ""}`}
              dangerouslySetInnerHTML={{ __html: contentHtml }}
            />
          )}
        </>
      )
    );
  };

  const isVisibledButtonCommand = (e: any) => {
    if (documentInfo?.userEmail !== email?.toLowerCase() && documentInfo?.docStatusId! > 2) return false;
    if (isOwner) return true;
    var role = checkPermission(e.row.data, user);
    return role === SharePointPermissionRole.write;
  };

  const isVisibledEditButtonCommand = (e: any) => {
    if (documentInfo?.userEmail !== email?.toLowerCase() && documentInfo?.docStatusId! > 2) return false;
    if (
      e.row.data.UserPermissions?.some(
        (role: any) => role.user.email === email?.toLowerCase() && role.roles.includes("update"),
      )
    )
      return true;
    if (isOwner) return true;
    var role = checkPermission(e.row.data, user);
    return role === SharePointPermissionRole.write;
  };

  const isVisibledRemoveButtonCommand = (e: any) => {
    if (documentInfo?.userEmail !== email?.toLowerCase() && documentInfo?.docStatusId! > 2) return false;
    if (isOwner) return true;
    if (isEqualBetweenSharepointUserAndLoginUser(e.row.data.CreatedUser, user)) {
      var role = checkPermission(e.row.data, user);
      return role === SharePointPermissionRole.write;
    }
  };

  const isVisibledPermissionButtonCommand = (e: any) => {
    if (e.row.data.IsContent && isOwner) return true;
    if (e.row.data.IsContent && isEqualBetweenSharepointUserAndLoginUser(e.row.data.CreatedUser, user)) {
      var role = checkPermission(e.row.data, user);
      return role === SharePointPermissionRole.write;
    }
  };

  const isVisibledShowCommentsButtonCommand = (e: any) => {
    if (!fileId || documentInfo?.docStatusId !== 3) return false;

    if (isOwner) return true;
    var role = checkPermission(e.row.data, user);
    return role !== SharePointPermissionRole.none || checkReviewers();
  };

  const isVisibledAddButtonCommand = (e: any) => {
    if (documentInfo?.userEmail !== email?.toLowerCase() && documentInfo?.docStatusId! > 2) return false;
    if (e.row.data.IsContent) return false;
    if (
      e.row.data.UserPermissions?.some(
        (role: any) => role.user.email === email?.toLowerCase() && role.roles.includes("update"),
      )
    )
      return true;
    if (isOwner) return true;
    var role = checkPermission(e.row.data, user);
    return role === SharePointPermissionRole.write;
  };

  const isVisibledAddContentButtonCommand = (e: any) => {
    if (documentInfo?.userEmail !== email?.toLowerCase() && documentInfo?.docStatusId! > 2) return false;
    if (e.row.node?.parent?.data?.IsContent) return false;
    if (
      e.row.data.UserPermissions?.some(
        (role: any) => role.user.email === email?.toLowerCase() && role.roles.includes("update"),
      )
    )
      return true;
    if (isOwner) return true;
    var role = checkPermission(e.row.data, user);
    return role === SharePointPermissionRole.write;
  };

  const isVisibledAddQuoteButtonCommand = (e: any) => {
    const node = e.row.node;
    if (documentInfo?.userEmail !== email?.toLowerCase() && documentInfo?.docStatusId! > 2) return false;
    if (node.data.IsContent) return false;
    if (node.children.findIndex((e: any) => e.data.isQuote) > -1) return false;
    if (
      e.row.data.UserPermissions?.some(
        (role: any) => role.user.email === email?.toLowerCase() && role.roles.includes("update"),
      )
    )
      return true;
    if (isOwner) return true;
    var role = checkPermission(e.row.data, user);
    return role === SharePointPermissionRole.write;
  };

  /**
   * If documentInfo or documentInfo.docReviewers is not defined, return false. Otherwise, return true
   * if the user is found in the docReviewers array.
   * @returns A boolean value.
   */
  const checkReviewers = () => {
    if (!documentInfo || documentInfo?.docReviewers?.toString() === "[]") return false;
    if (isOwner) return true;
    return documentInfo.docReviewers?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  const checkDetectors = () => {
    if (!documentInfo || documentInfo?.docDetectors?.toString() === "[]") return false;
    if (isOwner) return true;
    return documentInfo.docDetectors?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  const checkCheckers = () => {
    if (!documentInfo || documentInfo.docCheckers?.toString() === "[]") return false;
    if (isOwner) return true;
    return documentInfo.docCheckers?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  const checkApprovers = () => {
    const docApproved = documentInfo?.approvedBy ? JSON.parse(documentInfo.approvedBy) : [];
    if (!documentInfo || documentInfo.approvedBy === "[]") return false;
    if (isOwner) return true;
    return docApproved?.find((u: any) => u.Id === user.current.localAccountId) !== undefined;
  };

  //B1: Khi tao 1 tai lieu kiem tra file co quyen write thi return
  //B2: Neu ma file co quyen read thi kiem tra tung doan ben trong xem co quyen write hay k
  const checkPermission = (data: IDocumentContent, userLogin: any) => {
    if (user.isMasterUser) return SharePointPermissionRole.write;

    if (isOwner) return SharePointPermissionRole.write;

    //Check shareLinks are defined or not.
    //if yes, check permission
    if (
      isEqualBetweenSharepointUserAndLoginUser(data.CreatedUser, userLogin) === true ||
      isEqualBetweenSharepointUserAndLoginUser(data.ModifiedUser, userLogin) === true
    ) {
      return SharePointPermissionRole.write;
    }

    if (!data || !data.ShareLinks || data.ShareLinks.length === 0) {
      return SharePointPermissionRole.none;
    }

    return checkPermissionFromShareLinks(data.ShareLinks, userLogin);
  };

  const checkPermissionFromShareLinks = (shareLinks: Array<ISharepointLink>, userLogin: any) => {
    if (!shareLinks || shareLinks.length === 0) {
      return SharePointPermissionRole.read;
    }

    const links = shareLinks.filter(
      (l: ISharepointLink) =>
        !l.users ||
        l.users.length === 0 ||
        l.users.find((u: ISharepointUser) => isEqualBetweenSharepointUserAndLoginUser(u, userLogin)),
    );

    let roles: Array<string> = [];
    links.forEach((l: ISharepointLink) => {
      l.roles?.forEach((r) => roles.push(r));
    });

    if (roles.find((l) => l === SharePointPermissionRole.write)) {
      return SharePointPermissionRole.write;
    }

    if (roles.find((l) => l === SharePointPermissionRole.read)) {
      return SharePointPermissionRole.read;
    }

    return SharePointPermissionRole.none;
  };

  const renderHeader = () => {
    return (
      !isMultipleChoose && (
        <EditorHeader
          content={mappedData}
          documentInfo={documentInfo}
          isChangedViewMode={true}
          isAdmin={userAdmin?.id}
        />
      )
    );
  };

  const onComment = (e: any) => {
    setCurrentItem(e.row.data);
    setValueComment(e.row.data.Comments);
    setOpenContentComment(!openContentComment);
  };

  const onViewHistory = async (e: any) => {
    const id = e.row.data.Id;
    await DocumentContentService.getHistory(id)
      .then((res: any) => {
        setContentHistory(res.data.value);
      })
      .catch((error) => {
        CreateNotification({
          title: "Thông báo",
          body: "Không đọc được thông tin tài liệu, vui lòng thử lại",
          icon: "/icons/error.png",
        });
        console.log(error);
      });
    setOpenContentHistory(!openContentHistory);
  };

  const getRoot = (node: any): any => {
    if (node.level !== 0) linkTitle += node.data.Title ? node.data.Title + " | " : "";
    else {
      linkTitle += node.data.Title ? node.data.Title : "";
      return;
    }
    getRoot(node.parent);
  };

  const reverseStringByDelimiter = (str: any, delimiter: any) => {
    var arr = str.split(delimiter);
    arr.reverse();
    var reversedStr = arr.join(delimiter);
    return reversedStr;
  };

  const getPositionContent = (e: any) => {
    if (e.data.IsContent && e.level > 0) {
      return ", Nội dung " + (e.node.parent.children.map((c: any) => c.key).indexOf(e.key) + 1);
    }
  };

  const handleReader = () => {
    let arrUser: any = [...docReader];
    let today = new Date();
    const currentUser = {
      id: user.current.localAccountId,
      name: user.current.name,
      email: user.current.username,
      timeRead: today,
    };
    if (arrUser.findIndex((e: any) => e.id === currentUser.id) === -1) {
      arrUser.push(currentUser);
      const fields = {
        docReaders: JSON.stringify(arrUser),
      };

      mutate(
        {
          id: documentInfo?.id + "",
          body: fields,
        },
        {
          onSuccess() {
            CreateNotification({
              title: "Xác nhận đã đọc thành công",
              body: "Thông tin anh/chị đã được xác nhận. Xin cảm ơn!",
              icon: "/icons/success.png",
            });
            StatisticsEmployeeService.updateUserReadDoc({
              docId: documentInfo?.docWorkingId,
              email: currentUser.email,
            });
            queryClient.invalidateQueries({ queryKey: ["document-info"] });
          },
          onError() {},
        },
      );
    }
  };

  const handleReader_GroupAccount = async ({ userId, userName }: { userId: string; userName: string }) => {
    let arrUser: any = [...docReader];
    let today = new Date();
    const currentUser = {
      id: userId,
      name: userName,
      email: user.current.username,
      timeRead: today,
    };
    if (arrUser.findIndex((e: any) => e.id === currentUser.id) === -1) {
      arrUser.push(currentUser);
      const fields = {
        docReaders: JSON.stringify(arrUser),
      };
      mutate(
        {
          id: documentInfo?.id + "",
          body: fields,
        },
        {
          onSuccess() {
            queryClient.invalidateQueries({ queryKey: ["document-info"] });
            CreateNotification({
              title: "Xác nhận đã đọc thành công",
              body: "Thông tin anh/chị đã được xác nhận. Xin cảm ơn!",
              icon: "/icons/success.png",
            });
            StatisticsEmployeeService.updateUserReadDoc({
              docId: documentInfo?.docWorkingId,
              email: currentUser.email,
            });
          },
          onError() {},
        },
      );
    } else {
      CreateNotification({
        title: "Cập nhật thông tin thất bại",
        body: "Anh/Chị đã đọc tài liệu này!",
        icon: "/icons/warning.png",
      });
    }
    setIsShowReadButton(false);
    form.resetFields();
  };

  const handlePaletteButtonClick = (e: any) => {
    const id = e.row.data.Id;
    history.push({ pathname: Routes.documentDiagram.path.replace(":id", id), state: { data: e.row.data } });
  };

  const isVisibleWarningButton = (e: any) => {
    const data = e.row?.data || e.data;
    var role = checkPermission(data, user);
    return (
      role !== SharePointPermissionRole.none && linkContentList?.findIndex((c: any) => c.ContentId === data.Id) !== -1
    );
  };

  const getNumberEdit = async (content: any) => {
    const id = getFirstAnchorId(content);
    let numberEdit = 0;
    if (id) {
      try {
        const result = await DocumentContentService.get(id);
        numberEdit = result || 0;
      } catch (error) {
        console.log(error);
      }
    }
    return numberEdit;
  };

  const isVisibleWarning2Button = async (e: any) => {
    var role = checkPermission(e.row.data, user);
    try {
      const numberEdit = await getNumberEdit(e.row.data.Content);
      const index = linkContentList?.findIndex(
        (c: any) => c.ContentId === getFirstAnchorId(e.row.data.Content) && c.ContentLastModified !== numberEdit,
      );
      await new Promise((resolve) => setTimeout(resolve, 3000));
      return role !== SharePointPermissionRole.none && index !== -1;
    } catch (error) {
      // Handle any errors that might occur during the function execution
      console.error("Error occurred:", error);
      return false; // Or true, depending on how you want to handle errors
    }
  };

  const handleContentPermission = (rowData: any) => {
    searchParams.set("customId", rowData.row.key);
    replaceSearchParams(searchParams);
    setCustomId(rowData.row.key);
    setIsOpenPermissionContentModal(true);
  };

  const editContent = (e: any) => {
    if (isVisibleWarningButton(e)) {
      Modal.confirm({
        title: <span style={{ fontSize: "34px" }}>Thông báo</span>,
        content: (
          <div style={{ minHeight: 300, fontSize: "30px" }}>
            Tài liệu đang được đính kèm cân nhắc trước khi sửa đổi !
          </div>
        ),
        okText: "Xác nhận",
        okType: "danger",
        width: 1000,
        centered: true,
        onOk: () => {
          e.component.editRow(e.row.rowIndex);
        },
        okButtonProps: { type: "primary", size: "large" },
        cancelButtonProps: { size: "large" },
        cancelText: "Huỷ",
      });
    } else {
      e.component.editRow(e.row.rowIndex);
    }
  };

  const AntCountDown = <Statistic.Countdown format="ss" value={readTime} onFinish={() => setIsShowReadButton(true)} />;

  useEffect(() => {
    if (mappedData?.length > 0 && location.hash) {
      const timer = setTimeout(() => {
        const element = document.getElementById(location.hash.replace("#", ""));
        if (element) element.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isLoading, location, mappedData]);

  useLayoutEffect(() => {
    const widths = mappedData.map((item) => {
      // Tạo thẻ span ảo
      const virtualSpan = document.createElement("div");

      // Áp dụng tất cả style giống như thẻ thật
      virtualSpan.style.cssText = `
        flex-shrink: 0;
        font-size: 14pt;
        text-transform: uppercase;
        font-weight: bold;
        visibility: hidden;
        position: absolute;
        top: -9999px;
        left: -9999px;
        white-space: nowrap;
      `;

      // Set nội dung text
      virtualSpan.textContent = item.prefix; // hoặc item.text, tùy theo data structure

      // Thêm vào DOM để browser tính toán
      document.body.appendChild(virtualSpan);

      // Lấy width thực tế
      const actualWidth = virtualSpan.getBoundingClientRect().width;

      // Xóa thẻ ảo ngay lập tức
      document.body.removeChild(virtualSpan);

      return actualWidth;
    });

    // Tìm max width
    const maxWidth = Math.max(...widths);

    spanWidthRef.current = Math.ceil(maxWidth + 2);
  }, [mappedData]);

  if (isLoading) return <Spin />;

  console.log(mappedData);

  return (
    <div className="content__custom-editor">
      {!isShowReadButton && isPublishStatus && !isRead && (
        <h3 className="text-danger">Anh/Chị vui lòng xác nhận sau khi đã đọc tài liệu</h3>
      )}
      <TreeList
        id="content__custom-editor"
        wordWrapEnabled={true}
        dataSource={mappedData}
        showRowLines={viewMode === "edit"}
        showBorders={true}
        columnAutoWidth={true}
        showColumnHeaders={viewMode === "preview" || isMultipleChoose}
        showColumnLines={viewMode === "edit"}
        allowColumnReordering={false}
        allowColumnResizing={false}
        dataStructure="plain"
        rowAlternationEnabled={false}
        keyExpr="CustomId"
        parentIdExpr="CustomParentId"
        onInitNewRow={initNewRow}
        onRowUpdating={updateRow}
        onRowInserted={newRow}
        onRowRemoved={deleteRow}
        autoExpandAll={true}
      >
        <Scrolling mode="standard" />
        <RemoteOperations filtering={true} sorting={true} />
        {isMultipleChoose && <Selection allowSelectAll={true} recursive={true} mode="multiple" />}
        {viewMode === "edit" && (
          <Editing
            allowAdding={isOwner}
            allowUpdating={true}
            allowDeleting={true}
            mode="form"
            texts={{
              confirmDeleteTitle: "Thông báo",
              confirmDeleteMessage: "Anh/Chị muốn xóa đoạn văn bản này ?",
              saveRowChanges: "Lưu",
              cancelRowChanges: "Hủy",
              addRow: "Thêm tiêu đề",
            }}
          />
        )}
        <Column
          width={794}
          fixed={true}
          fixedPosition="left"
          allowResizing={true}
          dataField="Content"
          alignment="left"
          allowSorting={false}
          dataType="string"
          editCellRender={renderHtmlEditor || RenderHTMLDiagram}
          headerCellRender={renderHeader}
          cellRender={contentCellRender}
          cssClass="white-space: pre-wrap!important; font-family:'times new roman';"
        />
        <Column
          dataField="isQuote"
          caption="."
          visible={false}
          sortOrder="desc"
          allowEditing={false}
          editCellRender={() => null}
          allowHiding={true}
        />

        {viewMode === "edit" ? (
          <Column type="buttons">
            <Button
              name="new"
              icon="add"
              hint="Thêm mục con"
              onClick={addNewTitle}
              visible={isMultipleChoose ? false : isVisibledAddButtonCommand}
            />
            <Button
              name="addContent"
              icon="textdocument"
              hint="Thêm nội dung mới"
              onClick={addNewContent}
              visible={isMultipleChoose ? false : isVisibledAddContentButtonCommand}
            />
            <Button
              name="addQuote"
              icon="blockquote"
              hint="Thêm trích dẫn mới"
              onClick={addNewQuote}
              visible={isMultipleChoose ? false : isVisibledAddQuoteButtonCommand}
            />
            <Button
              name="editContent"
              icon="edit"
              hint="Chỉnh sửa"
              onClick={editContent}
              visible={isMultipleChoose ? false : isVisibledEditButtonCommand}
            />

            <Button
              name="warning"
              icon="warning"
              cssClass="custom-button-class"
              hint="Tài liệu đang được đính kèm, cân nhắc trước khi thay đổi"
              visible={isVisibleWarningButton}
            />

            <Button
              name="attach"
              icon="attach"
              hint="Nội dung tài liệu được đính kèm đã bị thay đổi. Vui lòng kiểm tra lại"
              render={(rowData) => (
                <WarningButton
                  data={rowData}
                  isVisibleWarning2Button={isVisibleWarning2Button}
                  isMultipleChoose={isMultipleChoose}
                />
              )}
            />

            {isDropdownVisible && (
              <Button
                name="addComment"
                icon="comment"
                hint="Thêm bình luận"
                onClick={onComment}
                visible={isMultipleChoose ? false : isVisibledShowCommentsButtonCommand}
                cssClass="datagrid-custom-button-size"
              />
            )}
            {
              <Button
                name="delete"
                icon="remove"
                hint="Xóa nội dung"
                visible={isMultipleChoose ? false : isVisibledRemoveButtonCommand}
              />
            }
            {isDropdownVisible && (
              <Button
                name="history"
                icon="clock"
                hint="Xem lịch sử chỉnh sửa"
                onClick={onViewHistory}
                visible={isMultipleChoose ? false : isVisibledButtonCommand}
              />
            )}
            {isDropdownVisible && (
              <Button
                name="link"
                icon="link"
                hint="Sao chép liên kết để đính kèm vào văn bản"
                visible={isMultipleChoose ? false : isVisibledButtonCommand}
                onClick={getHyperLink}
              />
            )}
            {isDropdownVisible && (
              <Button
                name="palette"
                icon="palette"
                hint="Vẽ biểu đò"
                onClick={handlePaletteButtonClick}
                visible={isMultipleChoose ? false : isVisibledButtonCommand}
              />
            )}
            <Button
              name="more"
              icon="more"
              hint="Xem thêm"
              onClick={handleClickButtonDropDown}
              visible={!isMultipleChoose}
            />
          </Column>
        ) : (
          <Column type="buttons">
            {action === "process" && step === "publish" && !isPublishStatus ? (
              <Button
                name="content-permission"
                icon="lock"
                hint="Phân quyền trên đoạn này"
                onClick={handleContentPermission}
                visible={isVisibledPermissionButtonCommand}
              />
            ) : (
              <Button
                name="link"
                icon="link"
                hint="Sao chép liên kết để đính kèm vào văn bản"
                visible={isMultipleChoose ? false : isVisibledButtonCommand}
                onClick={getHyperLink}
              />
            )}
          </Column>
        )}
      </TreeList>

      <ContentHistoryModal
        onClose={() => setOpenContentHistory(!openContentHistory)}
        isOpen={openContentHistory}
        contentHistory={contentHistory}
      />

      <EditDocumentLinkModal
        onClose={() => setIsShowLinkModal(false)}
        isOpen={isShowLinkModal}
        linkModalData={linkModalData}
        onLinkSubmit={() => {}}
      />
      <ContentComment
        onClose={() => setOpenContentComment(!openContentComment)}
        isOpenContentComment={openContentComment}
        onCloseContentComment={closeContentComment}
        onValueComment={valueComment}
        setState={setValueComment}
        user={user}
      />
      <EditorContentPermissionModal
        onClose={() => setIsOpenPermissionContentModal(!isOpenPermissionContentModal)}
        isOpen={isOpenPermissionContentModal}
        customId={customId}
      />

      {isPublishStatus ? (
        <div className="d-flex column justify-content-between">
          <div style={{ maxWidth: "1111px" }}>
            {documentInfo?.Tags?.map((tag: any, index: number) => (
              <Badge
                variant="secondary"
                className="mx-1 "
                key={index}
                style={{ whiteSpace: "normal", minWidth: 100, marginTop: "2px", cursor: "pointer" }}
                onClick={() => history.push(`/document?status=tags&tags=${tag?.label || tag.toString()}`)}
              >
                {getTagLabel(tag?.label || tag)}
              </Badge>
            ))}
          </div>
          {isPublishStatus && (!isGroupUser || isRead) && (
            <AntButton
              size="large"
              disabled={isRead || isUpdateLoading || !isShowReadButton}
              type={isRead ? "ghost" : "primary"}
              className={"float-right mt-2 d-flex justify-content-center align-items-center"}
              onClick={handleReader}
            >
              {isRead ? "Anh/Chị đã đọc tài liệu này" : isShowReadButton ? "Tôi đã đọc" : AntCountDown}
            </AntButton>
          )}
          {isGroupUser && isPublishStatus && (
            <Box className="my-2" title="Khu vực dành cho tài khoản dùng chung VIAGS">
              <Form onFinish={handleReader_GroupAccount} form={form}>
                <div className="px-2 d-flex justify-content-space-around">
                  <Space>
                    <Form.Item
                      name={"userId"}
                      rules={[
                        {
                          required: true,
                          message: `Vui lòng nhập mã nhân viên!`,
                        },
                      ]}
                    >
                      <Input placeholder="Nhập mã nhân viên" />
                    </Form.Item>
                    <Form.Item
                      name={"userName"}
                      rules={[
                        {
                          required: true,
                          message: `Vui lòng nhập tên nhân viên!`,
                        },
                      ]}
                    >
                      <Input placeholder="Nhập tên nhân viên" />
                    </Form.Item>
                    <AntButton
                      disabled={!isShowReadButton}
                      type={!isShowReadButton ? "ghost" : "primary"}
                      htmlType="submit"
                      className={"d-flex mr-2 justify-content-center align-items-center"}
                      style={{ marginBottom: "23px" }}
                    >
                      {isShowReadButton ? "Xác nhận" : AntCountDown}
                    </AntButton>
                  </Space>
                </div>
              </Form>
            </Box>
          )}
        </div>
      ) : (
        <div style={{ maxWidth: "1111px" }}>
          {documentInfo?.Tags?.map((tag: any, index: number) => (
            <Badge
              variant="secondary"
              className="mx-1 "
              key={index}
              style={{ whiteSpace: "normal", minWidth: 100, marginTop: "2px", cursor: "pointer" }}
              onClick={() => history.push(`/document?status=tags&tags=${tag?.label || tag.toString()}`)}
            >
              {getTagLabel(tag?.label || tag)}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
});
